import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import requestcardColumns from "../../../const/Columns/requestcardColumns";
import { getCardRequests } from "../../../apis/cardRequestsapis";

const Requestedcards = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    fetchRequests();
  }, []);

  //   Run filtering only when users or searchText change
  useEffect(() => {
    if (requests?.length > 0) {
      const filtered = requests?.filter(
        (req) =>
          req.status?.toLowerCase().includes(searchText.toLowerCase()) ||
          String(req.userId) == searchText,
      );
      setFilteredList(filtered);
    }
  }, [searchText, requests]);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await getCardRequests();
      console.log("fkljdslkfs", res.result[0]);
      setRequests(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const columns = requestcardColumns();
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              {/* <Link to="/addUser" className="btn add-new btn-primary mb-3">
                Raise a Request
              </Link> */}
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by name or email"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredList.length > 0
                      ? filteredList
                      : requests?.length > 0
                        ? requests
                        : []
                  }
                  className="table-striped"
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Requestedcards;
